import React, { useEffect, useState } from "react";
import api from "../api";

export default function SignaturePhrase({ className = "", tone = "light" }) {
  const [phrase, setPhrase] = useState("");
  useEffect(() => {
    api.get("/settings/public").then((r) => setPhrase(r.data.signature_phrase || "")).catch(() => {});
  }, []);
  if (!phrase) return null;
  const color = tone === "dark" ? "text-[#5A3A4B]" : "text-[#F3E9DE]";
  return (
    <div className={`container-x ${className}`} data-testid="signature-phrase">
      <div className="mx-auto max-w-2xl text-center">
        <p className={`font-serif text-lg sm:text-xl italic ${color} leading-relaxed`}>
          « {phrase} »
        </p>
      </div>
    </div>
  );
}
